module.exports = __webpack_public_path__ + "static/birds-over-river-637b4f61b4832226386d6fba59debb0f.jpg";